import { ArrowBack } from "@mui/icons-material";
import { Divider, Grid2, Skeleton, Typography } from "@mui/material";
import { ListButton } from "@refinedev/mui";
import { ReactNode } from "react";

interface Props {
  name: string | undefined;
  children: ReactNode;
}

export const EditView = ({ name, children }: Props) => {
  return (
    <>
      <ListButton
        variant="outlined"
        sx={{
          borderColor: "GrayText",
          color: "GrayText",
          backgroundColor: "transparent",
        }}
        startIcon={<ArrowBack />}
      />
      <Divider
        sx={{
          marginBottom: "24px",
          marginTop: "24px",
        }}
      />
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          marginTop: "24px",
          marginBottom: "24px",
        }}
      >
        {name ?? (
          <Skeleton variant="text" sx={{ fontSize: "24px", width: "120px" }} />
        )}
      </Typography>
      <Grid2 container spacing={2}>
        {children}
      </Grid2>
    </>
  );
};
